/** Category tabs of the home rail (WAI-ARIA tabs, roving tabindex) and the prev/next scroll buttons. */
class ProductRail extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
    this.querySelector('[role="tablist"]').addEventListener('keydown', (event) => this.onKey(event));

    const section = this.closest('section') || this;
    section.querySelectorAll('[data-rail-step]').forEach((button) => {
      button.addEventListener('click', () => this.scroll(Number(button.dataset.railStep)));
    });
  }

  select(tab, focus) {
    this.tabs.forEach((item) => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (!panel) return;
      panel.hidden = !selected;
      if (selected) panel.querySelector('.scroller')?.scrollTo({ left: 0 });
    });
    if (focus) tab.focus();
  }

  onKey(event) {
    const index = this.tabs.indexOf(document.activeElement);
    if (index < 0) return;
    const moves = { ArrowRight: 1, ArrowLeft: -1, Home: -index, End: this.tabs.length - 1 - index };
    if (!(event.key in moves)) return;
    event.preventDefault();
    this.select(this.tabs[(index + moves[event.key] + this.tabs.length) % this.tabs.length], true);
  }

  scroll(direction) {
    const track = this.querySelector('[role="tabpanel"]:not([hidden]) .scroller');
    if (!track) return;
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: direction * Math.max(320, track.clientWidth * 0.8), behavior: smooth ? 'smooth' : 'auto' });
  }
}

if (!customElements.get('product-rail')) customElements.define('product-rail', ProductRail);
